import { Component, HostListener, inject, signal, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import {
  AutoComplete,
  AutoCompleteCompleteEvent,
  AutoCompleteSelectEvent,
} from 'primeng/autocomplete';
import { ButtonComponent, ButtonSeverity, ButtonSize } from '../../../../../shared/ui/button/button';
import { AppLayoutService } from '../../app-layout.service';
import { CalendarPlus02 } from '../../../../../shared/icons/calendar-plus-02/calendar-plus-02';
import { Bell02 } from '../../../../../shared/icons/bell-02/bell-02';
import { LocationAdminService } from '../../../../../shared/services/location-admin.service';
import {
  ClientAutocompleteItemResponse,
  ClientsAutocompleteGroupResponse,
  ClientsClient,
} from '../../../../../shared/model/fss.api';
import { NotificationService } from '../../../../../shared/services/notification.service';

@Component({
  standalone: true,
  selector: 'app-admin-header',
  imports: [AutoComplete, FormsModule, NgTemplateOutlet, ButtonComponent, CalendarPlus02, Bell02],
  templateUrl: './admin-header.html',
  styleUrl: './admin-header.scss',
})
export class AdminHeader {
  sidebarService = inject(AppLayoutService);
  adminLocation = inject(LocationAdminService);
  protected notificationService = inject(NotificationService);
  private _clients = inject(ClientsClient);

  protected readonly ButtonSeverity = ButtonSeverity;
  protected readonly ButtonSize = ButtonSize;

  @ViewChild('searchAutocomplete') searchAutocomplete?: AutoComplete;

  clientModel: ClientAutocompleteItemResponse | null = null;
  clientSuggestions = signal<ClientsAutocompleteGroupResponse[]>([]);

  constructor() {
    this.notificationService.loadUnreadCount();
  }

  @HostListener('document:keydown', ['$event'])
  handleSearchShortcut(event: KeyboardEvent): void {
    if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      this.searchAutocomplete?.inputEL?.nativeElement.focus();
    }
  }

  async searchClients(event: AutoCompleteCompleteEvent): Promise<void> {
    const res = await firstValueFrom(this._clients.getClientsAutocomplete(event.query));
    this.clientSuggestions.set(res.result ?? []);
  }

  onClientSelected(event: AutoCompleteSelectEvent): void {
    const item = event.value as ClientAutocompleteItemResponse;
    this.clientModel = null;
    this.clientSuggestions.set([]);
    this.adminLocation.routeToClientDetails(item.id!);
  }
}
